require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("./Box"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Paragraph = function Paragraph() {
  var lineCount = Math.floor(Math.random() * (6 - 3 + 1) + 3);
  var width = "".concat(Math.floor(Math.random() * (75 - 30 + 1) + 30), "%");
  return Array.from(Array(lineCount), function (e, i) {
    return _react["default"].createElement(_Box["default"], {
      key: i,
      height: 30,
      width: lineCount === i + 1 ? width : "100%",
      mb: lineCount === i + 1 ? 50 : 20
    });
  });
};

var _default = Paragraph;
exports["default"] = _default;